// extracted by mini-css-extract-plugin
module.exports = {"intro":"style_intro__P_uie g-grid-container g-grid","breadcrumbs":"style_breadcrumbs__QcR64","headshot":"style_headshot__W6MF_","text":"style_text__UCcFF","bio":"style_bio__aRsei"};